"use strict";

(function ($) {
  $.fn.scrollTo = function () {
    var that = this,
        $btnScroll = $('.js-scroll-to'); //Case for map

    if ($('.js-map-listing').length) {
      $(window).on('scroll', function () {
        var scrollTop = $(this).scrollTop(),
            documentH = $(document).height(),
            windowH = $(window).height(),
            topMax = windowH / 2,
            bottomMax = $('.js-footer').offset().top - windowH + $btnScroll.height() / 2 + 5;

        if ((scrollTop < topMax || scrollTop >= bottomMax) && $btnScroll.hasClass('up-fixed')) {
          $btnScroll.removeClass('up-fixed');
        } else if (scrollTop > topMax && scrollTop < bottomMax && !$btnScroll.hasClass('up-fixed')) {
          $btnScroll.addClass('up-fixed');
        }
      });
    }

    return this.click(function (e) {
      var target = $(this).data('scroll-to'),
          timing = $(this).data('timing') || 800,
          offset = $('.js-section-nav').length && $(window).width() > 899 ? $('.js-section-nav').height() * -1 : 0,
          bezier = [0.645, 0.045, 0.355, 1.000];
      e.preventDefault();

      if ($('.js-search').length && $(window).width() > 899) {
        offset -= $('.js-search').height();
      }

      if ($(target).length) {
        if ($('.js-private-nav').length && $('.js-private-nav').is('.is-open')) {
          $('.js-private-menu').removeClass('open');
          $('.js-main-private').removeClass('open-menu-private');
          $('.js-private-nav').removeClass('is-open');
          $('.js-panel-private').removeClass('open-menu-private');
          unfixBody();
        }

        $(this).parent().parent().find('li.current').removeClass('current');
        $(this).parent().addClass('current');
        $(target).velocity("scroll", {
          duration: timing,
          easing: [0.645, 0.045, 0.355, 1.000],
          offset: offset
        });
      }

      ;
    });
  };
})(jQuery);

$(function () {
  if ($('.js-scroll-to').length) {
    $('.js-scroll-to').scrollTo();
  }
});